/// <amd-module name="typeahead/features/RedirectCubaPackageSearch" />
/// <amd-dependency path="typeahead/core/context" name="coreContext"/>
import {FormSubmittedMessage} from "typeahead/core/message/FormSubmittedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {ISuggestionData} from "typeahead/core/Suggestion";
import {SiteParam, TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

interface IChildAges {
    childAges: number[];
}

interface IFormData {
    destinationId: string;
    fromDate: string;
    locale: string;
    originTla: string;
    rooms: IChildAges[];
    toDate: string;
    totalAdults: number;
    totalChildren: number;
}

const REDIRECT_SERVICE: string = "https://threepp-comingle." + (coreContext.environment === "prod" ? "prod-p" : "int") +
    ".expedia.com/all-inclusive-vacation-destination/api/v1/build3ppSrpLink";

export class RedirectCubaPackageSearch {
    private readonly applicableClientIds: string [] = ["Homepage", "AWSHomepage", "PackageLandingPage"];
    private readonly applicablePackageTypes: string [] = ["FH"];

    constructor() {
        TypeaheadMessage.subscribe(FormSubmittedMessage.getTopic(),
            (topic: string, message: FormSubmittedMessage) => {
                if (message.isFormValid() && this.isRedirectApplicable()) {
                    if (message.getEvent()) {
                        const redirectPath: string = this.getRedirectPath($(message.getEvent().currentTarget));
                        if (redirectPath) {
                            message.getEvent().preventDefault();
                            this.submitFormData(this.collectFormData(message.getEvent()), redirectPath);
                        }
                    }
                }
            });
    }

    private isRedirectApplicable(): boolean {
        const clientId: string = TypeaheadUtils.getClientId();
        const shortPackageType: string = TypeaheadUtils.getShortPackageType();
        return (this.applicableClientIds.indexOf(clientId) > -1 &&
            this.applicablePackageTypes.indexOf(shortPackageType) > -1);
    }

    private getRedirectPath($form: JQuery): string {
        const taJsonString: string = $form.find("input[data-gcw-field-type=destination]:visible").
            closest("div.autocomplete").find("input[data-gcw-storeable-name=gcw-destination-ta]").val();
        if (taJsonString) {
            const taJson: ISuggestionData = JSON.parse(taJsonString);
            if (taJson.redirectPath) {
                return window.location.protocol + "//" + window.location.host + taJson.redirectPath;
            }
        }
        return undefined;
    }

    private collectFormData(event: JQueryEventObject): IFormData {
        const formData: IFormData = {} as IFormData;
        formData.locale = TypeaheadUtils.getLocale();
        const $form: JQuery = $(event.target);
        const originData: string = $form.find("[data-gcw-storeable-name=gcw-origin-ta]").val();
        formData.originTla = originData ? (JSON.parse(originData)).airportCode : undefined;
        const destData: string = $form.find("[data-gcw-storeable-name=gcw-destination-ta]").val();
        formData.destinationId = destData ? (JSON.parse(destData)).regionId : undefined;

        formData.fromDate = $form.find("[data-gcw-storeable-name=gcw-start-date]").val();
        formData.toDate = $form.find("[data-gcw-storeable-name=gcw-end-date]").val();

        formData.rooms = [];
        formData.totalAdults = 0;
        formData.totalChildren = 0;
        const roomCount = Number($form.find("[data-gcw-storeable-name=gcw-num-rooms]").val());
        for (let i: number = 1; i <= roomCount; i++) {
            const adultCount: number = Number($form.find("[data-gcw-storeable-name=gcw-num-adults-" + i + "]").val());
            const childCount: number = Number($form.find("[data-gcw-storeable-name=gcw-num-children-" + i + "]").val());
            const infantCount: number = Number($form.find("[data-gcw-storeable-name=gcw-num-infants-" + i + "]").val());

            const childAges: number[] = [];
            for (let j: number = 1; j <= childCount; j++) {
                childAges.push(
                    Number($form.find("[data-gcw-storeable-name=gcw-child-age-" + i + "-" + j + "]").val()));
            }
            for (let j: number = 1; j <= infantCount; j++) {
                childAges.push(1);
            }
            formData.rooms.push({childAges});
            formData.totalAdults += adultCount;
            formData.totalChildren += childCount;
            formData.totalChildren += infantCount;
        }
        return formData;
    }

    private submitFormData(data: IFormData, defaultRedirectPath: string): void {
        $.ajax({
            beforeSend: (jqXHR, settings) => {
                this.setRequestHeaders(jqXHR);
            },
            data: JSON.stringify(data),
            dataType: "json",
            error: () => {
                location.href = defaultRedirectPath;
            },
            success: ((response) => {
                if (response.srpUrl) {
                    window.location.href = response.srpUrl;
                } else {
                    location.href = defaultRedirectPath;
                }
            }),
            type: "POST",
            url: REDIRECT_SERVICE,
        });
    }

    private setRequestHeaders(jqXHR: JQueryXHR): void {
        const guid = TypeaheadUtils.getGuid();
        jqXHR.setRequestHeader("Content-Type", "application/json");
        jqXHR.setRequestHeader("Client-Token", "ess-cuba-redirect");
        jqXHR.setRequestHeader("Session-ID", guid);
        jqXHR.setRequestHeader("Transaction-ID", guid);
        jqXHR.setRequestHeader("Message-ID", guid);
        jqXHR.setRequestHeader("Site-Id", coreContext.siteid);
        jqXHR.setRequestHeader("Tpid", String(TypeaheadUtils.getSiteParamValue(SiteParam.tpid)));
        jqXHR.setRequestHeader("Eapid", String(TypeaheadUtils.getSiteParamValue(SiteParam.eapid)));
        jqXHR.setRequestHeader("Duaid", String(TypeaheadUtils.getCookie("DUAID")));
    }
}
